export type LngLatBounds = [[number, number], [number, number]]; // [[minLng, minLat], [maxLng, maxLat]]

/**
 * Расчет границ (bounds) по массиву координат - полностью соответствует официальной документации Яндекса
 */
export const getBounds = (coordinates: number[][]): LngLatBounds => {
  let minLat = Infinity,
    minLng = Infinity;
  let maxLat = -Infinity,
    maxLng = -Infinity;

  for (const coords of coordinates) {
    const lat = coords[1];
    const lng = coords[0];

    if (lat < minLat) minLat = lat;
    if (lat > maxLat) maxLat = lat;
    if (lng < minLng) minLng = lng;
    if (lng > maxLng) maxLng = lng;
  }

  return [
    [minLng, minLat],
    [maxLng, maxLat],
  ] as LngLatBounds;
};
